@let isArabic = isArabic$ | async;

<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow-lg rounded">
        <div class="card-header text-center bg-dark text-primary">
          <h3>{{ 'REGISTER' | translate }}</h3>
        </div>
        <div class="card-body">
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <!-- Email -->
            <div class="mb-3">
              <label>{{ 'EMAIL' | translate }}</label>
              <input
                type="email"
                formControlName="email"
                class="form-control"
                [ngClass]="{ 'is-invalid': isSubmitted && formControls['email'].invalid }"
              />
              @if (email?.invalid && email?.touched) {
                <div class="invalid-feedback d-block">
                  @if (email?.errors?.['required'] || email?.errors?.['email']) {
                    <div>{{ 'ENTER_VALID_EMAIL' | translate }}</div>
                  }
                </div>
              }
            </div>

            <div class="mb-3">
              <label>{{ 'NAME' | translate }}</label>
              <input
                type="name"
                formControlName="name"
                class="form-control"
                [ngClass]="{ 'is-invalid': isSubmitted && formControls['name'].invalid }"
              />
              @if (name?.invalid && name?.touched) {
                <div class="invalid-feedback d-block">
                  @if (name?.errors?.['required']) {
                    <div>{{ 'VALID_NAME_REQUIRED' | translate }}</div>
                  }
                  @if (name?.errors?.['minlength']) {
                    <div>{{ 'VALID_NAME_MIN_LENGTH' | translate }}</div>
                  }
                  @if (name?.errors?.['maxlength']) {
                    <div>{{ 'VALID_NAME_MAX_LENGTH' | translate }}</div>
                  }
                </div>
              }
            </div>

            <div class="mb-3 contact-number-input">
              <label>
                {{ 'MOBILE' | translate }}
              </label>

              <app-phone-number-input
                formControlName="phoneNumber"
                [required]="true"
                defaultCountry="SY"
                label="MOBILE"
                hint="REGISTER_PHONE_HINT"
              ></app-phone-number-input>

              @if ((phoneNumber?.touched || isSubmitted) && phoneNumber?.invalid) {
                <div class="invalid-feedback d-block">
                  @if (phoneNumber?.errors?.['required']) {
                    <div>
                      {{ 'VALID_PHONE_REQUIRED' | translate }}
                    </div>
                  }

                  @if (phoneNumber?.errors?.['invalidPhoneNumber']) {
                    <div>
                      {{ 'VALID_PHONE_PETTERN' | translate }}
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Password -->
            <div class="mb-3">
              <label for="password" class="form-label">{{ 'PASSWORD' | translate }}</label>
              <div class="input-group">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  id="password"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': isSubmitted && formControls['password'].invalid }"
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary eye-slash-btn"
                  (click)="togglePasswordVisibility()"
                  tabindex="-1"
                >
                  <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </div>
              <ul class="text-danger small mt-2">
                <li [class.text-success]="hasMinLength">
                  {{ 'REGISTER_PASSWORD_MIN' | translate }}
                </li>
                <li [class.text-success]="hasUpperCase">
                  {{ 'REGISTER_PASSWORD_UPP' | translate }}
                </li>
                <li [class.text-success]="hasNumber">{{ 'REGISTER_PASSWORD_NO' | translate }}</li>
                <li [class.text-success]="hasSpecialChar">
                  {{ 'REGISTER_PASSWORD_SPECIAL' | translate }}
                </li>
              </ul>
            </div>

            <!-- Confirm Password -->
            <div class="mb-3">
              <label for="confirmPassword" class="form-label">{{
                'REGISTER_CONFIRM_PASSWORD' | translate
              }}</label>
              <div class="input-group">
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  formControlName="confirmPassword"
                  id="confirmPassword"
                  class="form-control"
                  [ngClass]="{
                    'is-invalid': isSubmitted && formControls['confirmPassword'].invalid,
                  }"
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary eye-slash-btn"
                  (click)="toggleConfirmPasswordVisibility()"
                  tabindex="-1"
                >
                  <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
                @if (confirmPassword?.invalid && confirmPassword?.touched) {
                  <div class="invalid-feedback d-block">
                    @if (registerForm.errors?.['passwordsMismatch']) {
                      <div>{{ 'CONFIRM_PASSWORD_MISMATCH' | translate }}</div>
                    }
                    @if (confirmPassword?.errors?.['required']) {
                      <div>{{ 'CONFIRM_PASSWORD' | translate }}</div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-check mb-3">
              <input
                type="checkbox"
                class="form-check-input"
                id="terms"
                formControlName="termsAccepted"
                [ngClass]="isArabic ? 'float-end ms-2' : ''"
              />

              <label class="form-check-label" for="terms">
                {{ 'I_ACCEPT_THE' | translate }}
                <a routerLink="/terms" target="_blank">{{ 'TERMS' | translate }}</a>
              </label>
              @if (!termsAccepted?.value && termsAccepted?.touched) {
                <div class="invalid-feedback d-block">
                  <div>{{ 'TERMS_REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <!-- Spinner and Button -->
            <div class="mb-3 text-center">
              <button
                type="submit"
                class="btn btn-primary w-100"
                [disabled]="isLoading || registerForm.invalid || !termsAccepted?.value"
              >
                @if (isLoading) {
                  <app-loading
                    class="align-content-center"
                    [height]="20"
                    theme="dark"
                  ></app-loading>
                }
                {{ 'REGISTER' | translate }}
              </button>
            </div>
          <p><a routerLink="/data-protection" target="_blank" rel="noopener">{{ 'DATA_PROTECTION' | translate }}</a></p></form>
        </div>
        <div class="card-footer text-center bg-dark text-primary">
          {{ 'REGISTER_HAS_ACCOUNT' | translate }}
          <a routerLink="/login">{{ 'REGISTER_LOG_HERE' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
